import { ExtHttpLib } from './http-lib';
import * as R from 'ramda';
import * as querystring from 'qs';
import { CacheStrategy } from '../../../services/http/cache-strategy';
import { HttpCache } from '../../../services/http/http-cache';
import { isEmpty } from 'ramda';

export let baseUrl = 'https://dev.berlin3.com';
export const createHttpHeaderOptions = ({
  cacheStrategy = CacheStrategy.REQUEST_FIRST,
  cancelToken   = undefined,
  noJsonOutput = false
} = {}) => ({
  cacheStrategy,
  cancelToken,
  noJsonOutput
});

export let clientName = process.env.VUE_APP_CLIENTNAME;
function assignBaseUrl() {


  if (/(localhost)|(192.168)/.test(location.origin)) {
    baseUrl = process.env.VUE_APP_BASE_URL;
    // console.log(`Setting Base URL to default (${baseUrl})`);
  }
  else {
    baseUrl = `${location.origin}`;
    console.log(`Setting Base URL to ${baseUrl}`)
  }

  let clientRe = (new RegExp(`/(.*)/v2/`, 'i')).exec(location.pathname);
  if (clientRe?.[1]) {
    clientName = clientRe?.[1];
  }

  // Frontend Redirection to app.details.eu
  // if (isDev() && ![
  //   "updatecheck2", "designcheck", "big_fat_demo_agency", "berlin3"
  // ].includes(clientName)) {
  //   // Redirect to app.details.eu instead
  //   window.location.href = `https://app.details.eu${location.pathname}`;
  // }
}
// function assignBaseUrl() {
//   if (/(localhost)|(192.168)/.test(location.origin)) {
//     baseUrl = 'https://dev.berlin3.com';
//      console.log(`Setting Base URL to default (${baseUrl})`);
//   } 
  
//   else {
//     baseUrl = `${location.origin}`;
//     console.log(`Setting B2B Base URL to  ${baseUrl}`)
//   }

//   let clientRe = (new RegExp(`/(.*)/v2/`)).exec(location.pathname);
//   if (clientRe && clientRe[1]) {
//     clientName = clientRe[1];
//   }
// }
assignBaseUrl();
export let clientId = 'designcheck';
// const assignClientId = () => {
//   const clientResult = /\/(.*)\/v2\//i.exec(window.location.pathname);
//   if (clientResult && clientResult[1]) {
//     clientId = clientResult[1];
//     console.log(`Client ID - ${clientId}`);
//   }
// };


// assignClientId();


const responseInterceptor = ExtHttpLib.interceptors.response.use((response) => {
  console.warn(response);
  return response;
}, (error) => {
  switch(error.message) {
    case 'Request failed with status code 403': {
      console.log('403 FORBIDDEN');
      console.error(router.currentRoute);

      if (isValidRedirectionRoute(router.currentRoute.name)) {
        store.dispatch(SET_LOGIN_REDIRECT_ROUTE, router.currentRoute);
      }
      router.push({name: 'b2bLogin'});


      break;
    }

    default: {

    }
  }
  return Promise.reject(error);
});
 const get = async (ul = '', params = {}, options = createHttpHeaderOptions()) => {
  let url = `${baseUrl}/b2b/${clientName}` + ul;
  if (isEmpty(params)) {
    throw Error(`Params can't be empty`);
  }
  if (params && !params.output && !options.noJsonOutput) {
    params.output = JSON_STRING;
  }
  const finalURL = `${url}?${querystring.stringify(params)}`;
  if (options.cacheStrategy === CacheStrategy.CACHE_FIRST) {
    const cacheData = await HttpCache.get(finalURL);
    if (cacheData) {
      return cacheData;
    }

  }
  return ExtHttpLib.get(finalURL, {
    withCredentials: true,
    cancelToken: options.cancelToken
  }).then(res => {
    if (options.cahceStrategy !== CacheStrategy.REQUEST_ONLY) {
      HttpCache.save(finalURL, {data: res.data});
    }

    return res;
  })
  .catch(errorHandler);
};

const get2 = async (ul = '', params = {}, options = createHttpHeaderOptions()) => {
  let url = `${baseUrl}/b2b/${clientName}` + ul;
  
  let finalURL = '';
  if (isEmpty(params)) {
    finalURL = `${url}`;
  }
  else {
    finalURL = `${url}?${querystring.stringify(params)}`;
  }

  if (options.cacheStrategy === CacheStrategy.CACHE_FIRST) {

    const cacheData = await HttpCache.get(finalURL);
    if (cacheData) {
      return cacheData;
    }

  }

  return ExtHttpLib.get(finalURL, {
    withCredentials: true,
    cancelToken: options.cancelToken
  }).then(res => {
    if (options.cahceStrategy !== CacheStrategy.REQUEST_ONLY) {

      HttpCache.save(finalURL, res.data);

    }
    return res.data;
  })
  .catch(errorHandler);
};
const post = (url, data, options = createHttpHeaderOptions()) => {
  return ExtHttpLib.post(`${baseUrl}/b2b/${clientName}` + url, querystring.stringify(data, {arrayFormat: 'brackets'}), {
    withCredentials: true,
    cancelToken: options.cancelToken
  })
};
const post2 = (url, data, options = createHttpHeaderOptions()) => {
  return ExtHttpLib.post(`${baseUrl}/${clientName}` + url, querystring.stringify(data, {arrayFormat: 'brackets'}), {
    withCredentials: true,
    cancelToken: options.cancelToken
  })
};

const errorHandler = e => {
  if (ExtHttpLib.isCancel(e)) {
    throw e;
  } else {
    throw e;
  }
};

export const HttpClient = {
  get,
  post,
  get2,
  post2
};